//import React, { Component } from 'react'
//import CssBaseline from '@material-ui/core/CssBaseline'; import Container from '@material-ui/core/Container';
import React, { useState, useEffect, useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
// import { AppBar, Toolbar } from '@material-ui/core';
import MainContainer from '../../../components/MainContainer';
import { headerData } from '../../../data/modules/portal-header';
import { styled } from '@mui/material/styles';
import Badge from '@mui/material/Badge';
import Avatar from '@mui/material/Avatar';
import UserService from '../../../services/UserService';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid, IconButton, Typography } from '@material-ui/core';
import UserInfo from '../../family-member/tabs/UserInfo';
import TextField from "@material-ui/core/TextField";
import { FormControl } from "@material-ui/core";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Phone from "../../tools/Phone";
import { CreateTwoTone } from "@material-ui/icons";
import Alert from "@material-ui/lab/Alert";
import Message from "../../tools/Message";
import { useNavigate, useLocation } from "react-router-dom";
import DetailAccordions from './DetailAccordion';
import Spacer from '../../../components/Spacer';
import { isComputedPropertyName } from 'typescript';
import DirectionService from '../../../services/DirectionService';
import PlanningService from '../../../services/PlanningService';
import ConfirmationDialog from '../../tools/ConfirmationDialog';
import { PhotoCamera } from '@mui/icons-material';
import { set } from 'date-fns';
import LoadingSimpleBackdrop from '../../tools/LoadingSimpleBackdrop';
import CropDialog from './CropDialog';
import { Button } from '@mui/material';

const StyledBadge = styled(Badge)(({ theme }) => ({
    '& .MuiBadge-badge': {
        backgroundColor: '#44b700',
        color: '#44b700',
        boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
        '&::after': {
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            borderRadius: '50%',
            animation: 'ripple 1.2s infinite ease-in-out',
            border: '1px solid currentColor',
            content: '""',
        },
    },
    '@keyframes ripple': {
        '0%': {
            transform: 'scale(.8)',
            opacity: 1,
        },
        '100%': {
            transform: 'scale(2.4)',
            opacity: 0,
        },
    },
}));

const SmallAvatar = styled(Avatar)(({ theme }) => ({
    width: 22,
    height: 22,
    border: `2px solid ${theme.palette.background.paper}`,
}));

const useStyles = makeStyles((theme) => ({
    // IMPORTANT: Le conteneur principal doit permettre le scroll
    root: {
        width: '100%',
        minHeight: '100vh',
        height: 'auto',
        overflow: 'visible',
        position: 'relative',
        backgroundColor: '#f5f5f5',
        [theme.breakpoints.down('sm')]: {
            minHeight: '100vh',
            height: 'auto',
            overflow: 'visible',
            paddingBottom: '20px',
        }
    },
    container: {
        width: '100%',
        maxWidth: '1200px',
        margin: '0 auto',
        padding: '20px',
        height: 'auto',
        overflow: 'visible',
        [theme.breakpoints.down('sm')]: {
            padding: '8px 4px',
            height: 'auto',
            overflow: 'visible',
        }
    },
    welcom: {
        fontSize: '4.5rem',
        justifyContent: 'center',
        [theme.breakpoints.down('sm')]: {
            fontSize: '2.5rem',
        }
    },
    avatar: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '20px 0',
        width: '100%',
        [theme.breakpoints.down('sm')]: {
            padding: '10px 0',
        }
    },
    userAccount: {
        margin: "20px",
        [theme.breakpoints.down('sm')]: {
            margin: "8px 0",
        }
    },
    userAccountTitle: {
        borderBottom: "1px solid",
    },
    userAccountTitleBtn: {
        padding: "20px",
        [theme.breakpoints.down('sm')]: {
            padding: "10px",
        }
    },
    userPasswordTitle: {
        borderBottom: "1px solid",
    },
    userPasswordBtn: {
        padding: "20px",
    },
    userAccountChangePassword: {
        margin: "20px",
        [theme.breakpoints.down('sm')]: {
            margin: "8px 0",
        }
    },
    // Nouveaux styles pour le scroll
    scrollContainer: {
        height: 'auto',
        minHeight: '100%',
        overflow: 'visible',
        position: 'relative',
        [theme.breakpoints.down('sm')]: {
            height: 'auto',
            overflow: 'visible',
        }
    },
    contentWrapper: {
        width: '100%',
        height: 'auto',
        overflow: 'visible',
        [theme.breakpoints.down('sm')]: {
            height: 'auto',
            overflow: 'visible',
        }
    },
    avatarWrapper: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '16px 0',
        width: '100%',
        [theme.breakpoints.down('sm')]: {
            padding: '8px 0',
        }
    },
    dialogContent: {
        overflow: 'visible',
        [theme.breakpoints.down('sm')]: {
            padding: '16px 8px',
        }
    },
    dialogActions: {
        padding: '8px 16px',
        [theme.breakpoints.down('sm')]: {
            padding: '8px',
            flexDirection: 'column',
            '& .MuiButton-root': {
                width: '100%',
                margin: '4px 0',
            }
        }
    }
}));

function MyAccount() {
    const location = useLocation();
    const classes = useStyles();
    const [userInfo, setUserInfo] = useState({
        userId: "",
        userFirstName: "",
        userLastName: "",
        userEmail: "",
        userphone: "",
        userSex: "",
        userImage: ""
    });

    const [message, setMessage] = useState({
        open: false,
        color: 'green',
        messageInfo: '',
    });

    const navigate = useNavigate();
    const { open, color, messageInfo } = message;
    const [sexe, setSexe] = useState([]);
    const [isDisable, setIsDisable] = useState(true);
    const [isModifiedPassword, setIsModifiedPassword] = useState(false);
    const [form, setForm] = useState({
        newpassword: "",
        confirmpassword: ""
    });
    const [openLoadingSimpleBackdrop, setOpenLoadingSimpleBackdrop] = React.useState(false);
    const [isEmptyNewPass, setIsEmptyNewPass] = useState(false);
    const [isEmptyNewPassMessage, setIsEmptyNewPassMessage] = useState("");
    const [isEmptyConfirmPass, setIsEmptyConfirmPass] = useState(false);
    const [isEmptyConfirmPassMessage, setIsEmptyConfirmPassMessage] = useState("");
    const [IsCompatibleNewAndConfirmPassword, setIsCompatibleNewAndConfirmPassword] = useState(true);
    const [IsCompatibleNewAndConfirmPasswordMessage, setIsCompatibleNewAndConfirmPasswordMessage] = useState("");
    const apiUrl = process.env.REACT_APP_API_URL;

    const [dir, setDir] = useState([]);
    const [service, setService] = useState([]);
    const [users, setUsers] = useState([]);

    const [idservice, setIdservice] = useState(0);
    const [iddir, setIddir] = React.useState(0);
    const [iduser, setIdUser] = React.useState(0);
    const [idDelegate, setIdDelegate] = React.useState(0);
    const [showAddDelegateForm, setShowAddDelegateForm] = React.useState(true);
    const [showDelegateDetail, setShowDelegateDetail] = React.useState(false);
    const [expanded, setExpanded] = React.useState('panel1');
    const [loading, setLoading] = React.useState(false);
    const [newImage, setNewImage] = React.useState(null);
    const [idDelegateDetail, setidDelegateDetail] = React.useState([]);
    const [openDialogImage, setOpenDialogImage] = React.useState(false);
    const [selectedFile, setSelectedFile] = React.useState(null);
    const [confirmationDialog, setConfirmationDialog] = React.useState({
        openDialog: false,
        messageDialog: 'Voulez vous annuler la délégation?',
    });
    const { openDialog, messageDialog } = confirmationDialog;
    const [tempImage, setTempImage] = useState(null);
    const [cropping, setCropping] = useState(false);
    
    const handleChangePanel = (panel) => (event, newExpanded) => {
        setExpanded(newExpanded ? panel : false);
    };
    
    const fileInputRef = useRef(null);
    
    useEffect(() => {
        setOpenLoadingSimpleBackdrop(true);
        UserService.user_info().then((result) => {
            if (result) {
                setUserInfo({
                    userId: result.data.user_id,
                    userFirstName: result.data.first_name,
                    userLastName: result.data.last_name,
                    userEmail: result.data.email,
                    userphone: result.data.telephone,
                    userSex: result.data.sex_id,
                    userImage: result.data.name_image,
                    isSTG: result.data.isSTG
                });
                setOpenLoadingSimpleBackdrop(false);
            }
        });

        UserService.getSex().then((sex) => {
            if (sex) {
                setSexe(
                    sex.data.map((s) => {
                        return { sex_id: s.sex_id, name: s.name };
                    })
                );
            }
        });
        
        DirectionService.getDirection().then((res) => {
            if (res && res.status) {
                setDir(res.data);
            }
        });

        UserService.getUserDelegateAuthorityByUserId().then((results) => {
            if (results && results.status) {
                setIdDelegate(results.data);
                setidDelegateDetail(results.data);
                setIddir(results.data.user_delegate_direction);
                UserService.getAllUserByDirection(results.data.user_delegate_direction).then((results) => {
                    if (results && results.status) {
                        setUsers(results.data);
                    }
                })
                setIdUser({
                    "name": results.data.user_delegate_name,
                    "user_id": results.data.user_delegation_authority_userDelegateId,
                    "email": results.data.user_delegate_email
                });
                setShowAddDelegateForm(false);
            } else {
                setIdDelegate(0);
                setIdUser({
                    "name": "",
                    "user_id": 0,
                    "email": ""
                });
            }
        })
    }, [location]);

    useEffect(() => {
        if (idDelegate !== 0) {
            setShowDelegateDetail(true);
            setShowAddDelegateForm(false);
        } else {
            setShowDelegateDetail(false);
            setShowAddDelegateForm(true);
        }
    }, [idDelegate]);

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    function handleCloseMessage() {
        setMessage({ ...message, open: false });
    }

    function handleClickEditInfo() {
        setIsDisable(!isDisable);
    }

    function handleClickBtnSave() {

    }

    function handleClickEditPassword() {
        setIsModifiedPassword(!isModifiedPassword);
    }

    function handleClickBtnSavePassword() {
        if (!form.newpassword) {
            setIsEmptyNewPass(true);
            setIsEmptyNewPassMessage("Ce champ est obligatoire");
        } else if (!form.confirmpassword) {
            setIsEmptyConfirmPass(true);
            setIsEmptyConfirmPassMessage("Ce champ est obligatoire");
        } else if (form.newpassword !== form.confirmpassword) {
            setIsCompatibleNewAndConfirmPassword(false);
            setIsCompatibleNewAndConfirmPasswordMessage("Les mots de passe ne correspondent pas");
        } else {
            UserService.my_account_update_password(userInfo.userEmail, form.confirmpassword).then((result) => {
                if (result && result.status != 411) {
                    if (result.status) {
                        setMessage({ ...message, open: true, color: 'green', messageInfo: result.message });
                        setIsModifiedPassword(false);
                        setTimeout(function () { navigate("/"); }, 7000);
                    } else {
                        setMessage({ ...message, open: true, color: 'red', messageInfo: result.message });
                        setForm({ ...form, newpassword: "", confirmpassword: "" });
                    }
                } else {
                    setIsCompatibleNewAndConfirmPassword(false);
                    setIsCompatibleNewAndConfirmPasswordMessage(result.data.message);
                }
            });
        }
    }

    function handleFocusNewPassword() {
        setIsEmptyNewPass(false);
        setIsCompatibleNewAndConfirmPassword(true);
    }

    function handleFocusConfirmPassword() {
        setIsEmptyConfirmPass(false);
        setIsCompatibleNewAndConfirmPassword(true);
    }

    function handleChangeDirection(event) {
        const { name, value } = event.target;
        setIddir(value);
        setForm({ ...form, [name]: value });
        UserService.getAllUserByDirection(value).then((results) => {
            if (results && results.status) {
                setUsers(results.data);
            }
        })
    }

    function handleChangeService(ev) {
        const { name, value } = ev.target;
        setForm({ ...form, [name]: value });
        setIdservice(value);
    }

    function handleChangeUsers(ev, value) {
        setIdUser(value);
    }

    function handleClickBtnSaveDelegateAuthority() {
        setLoading(true);
        UserService.saveUserDelegateAuthority(iduser, idDelegate.user_delegation_authority_id).then((results) => {
            if (results && results.status) {
                setUsers(results.data);
                navigate("/myAccount");
                setExpanded("panel3");
                setLoading(false);
            } else {
                setLoading(false);
            }
        })
    }

    function handleClickBtnModifDelegateAuthority() {
        setShowAddDelegateForm(true);
        setShowDelegateDetail(false);
    }

    function handleClickBtnCancelDelegateAuthority() {
        setConfirmationDialog({ ...confirmationDialog, openDialog: true, messageDialog: 'Confirmer-vous la délégation de pouvoir?' });
    }

    const handleOpen = () => {
        setOpenDialogImage(true);
    };

    function closeDialog() {
        setConfirmationDialog({ ...confirmationDialog, openDialog: false, messageDialog: 'Confirmer-vous la délégation de pouvoir?' });
    }

    function confirmDialog() {
        setConfirmationDialog({ ...confirmationDialog, openDialog: false, messageDialog: 'Confirmer-vous la délégation de pouvoir?' });
        UserService.deleteUserDelegateAuthority(iduser, idDelegate.user_delegation_authority_id).then((results) => {
            if (results && results.status) {
                setIdUser({
                    "name": "",
                    "user_id": 0,
                    "email": ""
                });
                setLoading(false);
                setIdDelegate(0);
                setIddir(0);
                navigate("/myAccount");
                setExpanded("panel3");
            } else {
                setLoading(false);
            }
        })
    }

    function cancelDialog() {
        setConfirmationDialog({ ...confirmationDialog, openDialog: false });
    };

    const handleSaveImage = (e) => {
        e.preventDefault();
        setOpenDialogImage(false);
        setOpenLoadingSimpleBackdrop(true);

        if (!selectedFile) {
            console.error("Aucun fichier sélectionné");
            return;
        }

        const formData = new FormData();
        formData.append("photos", selectedFile);
        formData.append("name_image", userInfo.userFirstName);
        
        UserService.updateUserImage(userInfo.userId, formData).then((res) => {
            if (res) {
                setMessage({ ...message, open: true, color: 'green', messageInfo: "Mise à jour photo avec succés" });
                setUserInfo({ ...userInfo, userImage: res });
                setOpenLoadingSimpleBackdrop(false);
            } else {
                setMessage({ ...message, open: true, color: 'red', messageInfo: "Erreur lors de la mise à jour de la photo" });
                setOpenLoadingSimpleBackdrop(false);
            }
        })
        .catch((error) => {
            console.error("Erreur :", error);
            setOpenLoadingSimpleBackdrop(false);
        });
    };

    const handleClose = () => {
        setNewImage(null);
        setOpenDialogImage(false);
    };

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;
    
        const reader = new FileReader();
        reader.onloadend = () => {
            setTempImage(reader.result);
            setCropping(true);
        };
        reader.readAsDataURL(file);
    };

    const handleBrowseImage = () => {
        fileInputRef.current?.click();
    };

    const handleCropComplete = async (croppedUrl) => {
        const response = await fetch(croppedUrl);
        const blob = await response.blob();
        const file = new File([blob], 'cropped-image.jpg', { type: blob.type });
        setNewImage(croppedUrl);
        setSelectedFile(file);
        setTempImage(null);
        setCropping(false);
    };
    
    const handleCancelCrop = () => {
        setCropping(false);
    };

    return (
        <MainContainer {...headerData}>
            <LoadingSimpleBackdrop openLoadingSimpleBackdrop={openLoadingSimpleBackdrop} />
            <ConfirmationDialog 
                openDialog={openDialog} 
                messageDialog={messageDialog} 
                closeDialog={closeDialog} 
                confirmDialog={confirmDialog} 
                cancelDialog={cancelDialog} 
            />

            <Message 
                open={open} 
                color={color} 
                messageInfo={messageInfo} 
                handleClose={handleCloseMessage} 
            />
            
            {/* IMPORTANT: Conteneur principal avec scroll */}
            <div className={classes.root}>
                <div className={classes.container}>
                    <div className={classes.scrollContainer}>
                        <div className={classes.contentWrapper}>
                            {/* Avatar */}
                            <div className={classes.avatarWrapper}>
                                <Badge
                                    overlap="circular"
                                    anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                                    badgeContent={
                                        <label htmlFor="upload-avatar">
                                            <IconButton
                                                title='Cliquer pour mettre à jour votre photo'
                                                component="span"
                                                sx={{
                                                    backgroundColor: '#ffffff',
                                                    borderRadius: '50%',
                                                    boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.2)',
                                                    width: 36,
                                                    height: 36,
                                                    color: '#b3b3b3',
                                                    '@media (max-width: 600px)': {
                                                        width: 30,
                                                        height: 30,
                                                    }
                                                }}
                                                onClick={handleOpen}
                                            >
                                                <PhotoCamera sx={{ fontSize: 20 }} />
                                            </IconButton>
                                        </label>
                                    }
                                >
                                    <Avatar 
                                        alt={userInfo.userFirstName} 
                                        src={userInfo.userImage}
                                        sx={{ 
                                            width: 100, 
                                            height: 100, 
                                            cursor: 'pointer',
                                            '@media (max-width: 600px)': {
                                                width: 80,
                                                height: 80,
                                            }
                                        }}
                                        onClick={handleOpen} 
                                    />
                                </Badge>
                            </div>
                            
                            <Spacer y={2} />
                            
                            {/* DetailAccordions - Le composant qui pose problème */}
                            <DetailAccordions 
                                message={message} 
                                userInfo={userInfo} 
                                sexe={sexe}
                                isDisable={isDisable} 
                                form={form} 
                                isEmptyNewPass={isEmptyNewPass} 
                                loading={loading}
                                isEmptyNewPassMessage={isEmptyNewPassMessage} 
                                isEmptyConfirmPass={isEmptyConfirmPass}
                                isEmptyConfirmPassMessage={isEmptyConfirmPassMessage} 
                                IsCompatibleNewAndConfirmPassword={IsCompatibleNewAndConfirmPassword}
                                IsCompatibleNewAndConfirmPasswordMessage={IsCompatibleNewAndConfirmPasswordMessage} 
                                handleChangePassword={handleChange}
                                handleClickBtnSave={handleClickBtnSave} 
                                handleClickBtnSavePassword={handleClickBtnSavePassword}
                                handleFocusConfirmPassword={handleFocusConfirmPassword} 
                                handleFocusNewPassword={handleFocusNewPassword}
                                dir={dir} 
                                service={service} 
                                users={users} 
                                handleChangeDirection={handleChangeDirection}
                                handleChangeService={handleChangeService} 
                                handleChangeUsers={handleChangeUsers}
                                idDir={iddir} 
                                idservice={idservice} 
                                iduser={iduser} 
                                showAddDelegateForm={showAddDelegateForm}
                                handleClickBtnSaveDelegateAuthority={handleClickBtnSaveDelegateAuthority}
                                idDelegate={idDelegate} 
                                handleClickBtnModifDelegateAuthority={handleClickBtnModifDelegateAuthority}
                                showDelegateDetail={showDelegateDetail} 
                                expanded={expanded} 
                                handleChangePanel={handleChangePanel}
                                handleClickBtnCancelDelegateAuthority={handleClickBtnCancelDelegateAuthority} 
                            />
                        </div>
                    </div>
                </div>
            </div>

            {/* Dialog pour la photo */}
            <Dialog 
                open={openDialogImage} 
                onClose={handleClose}
                PaperProps={{
                    sx: {
                        width: '100%',
                        maxWidth: '450px',
                        margin: '16px',
                        '@media (max-width: 600px)': {
                            margin: '8px',
                            maxWidth: 'calc(100% - 16px)',
                        }
                    }
                }}
            >
                <DialogTitle id="customized-dialog-title">
                    <strong>Mettre à jour votre photo</strong>
                </DialogTitle>
                <DialogContent dividers className={classes.dialogContent}>
                    <div style={{ 
                        display: 'flex', 
                        flexDirection: 'column', 
                        alignItems: 'center',
                        width: '100%'
                    }}>
                        <Avatar
                            src={newImage || userInfo.userImage}
                            alt="votre photo"
                            sx={{ 
                                width: 140, 
                                height: 140, 
                                marginBottom: 4,
                                '@media (max-width: 600px)': {
                                    width: 100,
                                    height: 100,
                                    marginBottom: 2,
                                }
                            }}
                        />
                        <input
                            ref={fileInputRef}
                            accept="image/*"
                            id="upload-avatar"
                            type="file"
                            style={{ display: 'none' }}
                            onChange={handleImageChange}
                        />
                        <Button 
                            variant="outlined" 
                            onClick={handleBrowseImage} 
                            startIcon={<PhotoCamera />}
                            fullWidth={window.innerWidth < 600}
                        >
                            Parcourir une image
                        </Button>
                    </div>
                </DialogContent>
                <DialogActions className={classes.dialogActions}>
                    <Button onClick={handleClose} color="primary" variant="outlined">
                        Annuler
                    </Button>
                    <Button onClick={handleSaveImage} color="primary" variant="contained">
                        Enregistrer
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Crop Dialog */}
            {cropping && (
                <CropDialog
                    imageSrc={tempImage}
                    onCropComplete={handleCropComplete}
                    onCancel={handleCancelCrop}
                />
            )}
        </MainContainer>
    )
}

export default MyAccount;